export default __webpack_public_path__ + "static/media/BackArrow.055de861.png";